<template>
  <transition name="el-fade-in-linear">
    <div class="mark" v-show="popup" @click="closeMark">

      <div class="content" :style="{maxHeight:`${heightVue}px`}" @click.stop>
        <div class="contentNav" v-if="isNavTitle">
          <div></div>
          <div>{{ navTitle }}</div>
          <div><i class="el-icon-close" @click="$emit('close')"></i></div>
        </div>
        <div class="slotBox">
          <slot></slot>
        </div>
        <div style="min-height: 62px" v-if="isPlaceHolder"></div>
      </div>
    </div>
  </transition>
</template>
<script>
export default {
  name: "popup",
  props: {
    popup: {
      type: Boolean,
      default: true
    },
    heightVue: {
      type: Number,
      default: 400
    },
    navTitle: {
      type: String,
      default: '交易详情'
    },
    isNavTitle: {
      type: Boolean,
      default: false
    },
    isPlaceHolder: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {}
  },
  watch: {},
  methods: {
    closeMark() {
      if (!this.isNavTitle) {
        this.$emit('close')
      }
    }
  }
}
</script>


<style scoped lang="scss">
.mark {
  position: fixed;
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.2);
  top: 0;
  left: 0;
  z-index: 2000;
}

.content {
  background-color: white;
  border-top-right-radius: 15px;
  border-top-left-radius: 15px;
  position: fixed;
  bottom: 0;
  width: 100vw;
  transition: maxHeight 20s;
  display: flex;
  flex-direction: column;
}

.slotBox {
  flex: 1;
  overflow: auto;
}

.contentNav {
  display: flex;
  height: 50px;
  border-bottom: 1px solid #eee;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px;

  > div {
    font-size: 18px;
  }
}

</style>
